/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

export const SECRET_MODE = "/admin/secret-mode";
export const SECRET_MODE_TABS_PATH = `${SECRET_MODE}/:tabSlug(domain-manager|general-settings|story-settings|collection-settings|language-settings)`;
